// extracted by mini-css-extract-plugin
module.exports = {"wrap":"dear-manager-styles-module--wrap--2lOYN","bg":"dear-manager-styles-module--bg--1tGR3"};